// extracted by mini-css-extract-plugin
module.exports = {"newsCard":"NewsCard_newsCard__18RNu"};